<template>
    <div class="codelab-mission-answer" :id="blockId">
        
    </div>
</template>
<script>
const Blockly = window.Blockly;
import { mapState } from "vuex";
export default {
  name: "mission-answer",
  props: {
    xml: String,
    option: Object,
    scrollCenter: {
      type: Boolean,
      default: false
    },
    autoSize: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      workSpace: null,
      blockId: "codelab-mission-answer-" + new Date().getTime()
    };
  },
  computed: {
    ...mapState(["env$"]),
    mergedOption(){
      let option = this.option || {};
      return Object.assign({},{
        media: `${this.env$}static/js/blockly/media/`,
        readOnly: true,
        toolbox: "",
        theme: Blockly.Themes.Nuwa,
        move: {
          scrollbars: true,
          drag: true,
          wheel: false
        },
        zoom: {
          controls: false,
          wheel: false,
          startScale: 0.8,
          maxScale: 3,
          minScale: 0.3,
          scaleSpeed: 1.2
        }
      }, option);
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.initBlockly();
    });
  },
  methods: {
    initBlockly() {
      this.workSpace = Blockly.inject(this.blockId, this.mergedOption);
      let xml = this.xml;
      

      this.loadToWorkspace(xml);
      if (this.autoSize) {
        this.centerBlocklys();
      }
      if(this.scrollCenter){
        this.$nextTick(() => {
          let oldDragable = this.workSpace.options.moveOptions.drag;
          this.workSpace.options.moveOptions.drag = true;
          this.workSpace.scrollCenter();
          this.workSpace.options.moveOptions.drag = oldDragable;
        });
      }
    },
    loadToWorkspace(xml_str) {
      var xml = Blockly.Xml.textToDom(xml_str);
      Blockly.Xml.hardDomToWorkspace(xml, this.workSpace);
    },
    centerBlocklys() {
      this.$nextTick(() => {
        let container = document.querySelector("#" + this.blockId);
        let blcokSvg = container.querySelector("svg");
        let blocklyCanvas = blcokSvg.querySelector(".blocklyBlockCanvas");
        let clientRec = blocklyCanvas.getBoundingClientRect();
        let { height } = clientRec;
        blcokSvg.setAttribute("height", height + 40);
        container.style.height = height + 40 + "px";
      });
    },
    destroyed() {
      this.workSpace = null;
    }
  }
};
</script>
<style lang="scss">
.codelab-mission-answer {
  width: 100%;
  height: 100%;
  overflow: hidden;
  .injectionDiv {
    .blocklySvg {
      
      .blocklyMainBackground {
        stroke: none;
      }
    }
    .blocklyMainWorkspaceScrollbar {
      display: none;
    }
  }
}
</style>